// context/DrawerProvider/DrawerStore.ts
type DrawerSnapshot = {
  taskOpen: boolean
  ncoOpen: boolean
  mtbOpen: boolean
  accountingOpen: boolean
  projectOpen: boolean
}

type Listener = () => void

const listeners = new Set<Listener>()

const state: DrawerSnapshot = {
  taskOpen: false,
  ncoOpen: false,
  mtbOpen: false,
  accountingOpen: false,
  projectOpen: false,
}

const emit = () => {
  for (const l of listeners) l()
}

export const DrawerStore = {
  // --- subscribe/get for useSyncExternalStore ---
  subscribe(fn: Listener) {
    listeners.add(fn)
    return () => listeners.delete(fn)
  },
  get(): DrawerSnapshot {
    // return a stable reference or a shallow copy — stable reference is fine here
    return state
  },

  // --- actions (called by your Provider API) ---
  openTask() {
    if (!state.taskOpen) {
      state.taskOpen = true
      emit()
    }
  },
  closeTask() {
    if (state.taskOpen) {
      state.taskOpen = false
      emit()
    }
  },

  openNco() {
    if (!state.ncoOpen) {
      state.ncoOpen = true
      emit()
    }
  },
  closeNco() {
    if (state.ncoOpen) {
      state.ncoOpen = false
      emit()
    }
  },

  openMtb() {
    if (!state.mtbOpen) {
      state.mtbOpen = true
      emit()
    }
  },
  closeMtb() {
    if (state.mtbOpen) {
      state.mtbOpen = false
      emit()
    }
  },

  openAccounting() {
    if (!state.accountingOpen) {
      state.accountingOpen = true
      emit()
    }
  },
  closeAccounting() {
    if (state.accountingOpen) {
      state.accountingOpen = false
      emit()
    }
  },

  openProject() {
    if (!state.projectOpen) {
      state.projectOpen = true
      emit()
    }
  },
  closeProject() {
    if (state.projectOpen) {
      state.projectOpen = false
      emit()
    }
  },
}
